import { render, staticRenderFns } from "./MyDeliveryReceiptsList.vue?vue&type=template&id=707b75f6&scoped=true&"
import script from "./MyDeliveryReceiptsList.vue?vue&type=script&lang=js&"
export * from "./MyDeliveryReceiptsList.vue?vue&type=script&lang=js&"
import style0 from "./MyDeliveryReceiptsList.vue?vue&type=style&index=0&id=707b75f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707b75f6",
  null
  
)

export default component.exports